import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../config/config.service";
export class HerramientasService {
    constructor(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.headers = new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    cierreLlavesTbk() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/PagoTbk/CierreTbk`;
            try {
                return yield this.httpClient.post(url, null, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    apagarEquipo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/PagoTbk/ApagarEquipo`;
            try {
                return yield this.httpClient.post(url, null, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    reiniciarEquipo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/PagoTbk/ReiniciarEquipo`;
            try {
                return yield this.httpClient.post(url, null, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    compararClave(clave, tipo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const claveConfig = tipo === 1 ? config['uno'] : config['dos'];
            return clave === claveConfig;
        });
    }
}
HerramientasService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HerramientasService_Factory() { return new HerramientasService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: HerramientasService, providedIn: "root" });
